export default "__VITE_ASSET__DgX$qdxx__"